export const primary = {
    100: '#FFFFFF',
    98: '#F9F9FF',
    95: '#ECF1FF',
    90: '#D5E3FF',
    80: '#A7C8FF',
    70: '#76ACFF',
    60: '#4A91F0',
    50: '#2777D4',
    40: '#005EB3',
    30: '#004689',
    20: '#003061',
    10: '#001B3C',
    0: '#000000',
};
export default primary;
